import { render, staticRenderFns } from "./groupNav.vue?vue&type=template&id=6900826c"
import script from "./groupNav.vue?vue&type=script&lang=js"
export * from "./groupNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports